import { render, staticRenderFns } from "./SkeletonBody.vue?vue&type=template&id=56ea5c71&scoped=true&"
var script = {}
import style0 from "./SkeletonBody.vue?vue&type=style&index=0&id=56ea5c71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea5c71",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/reused-components/skeletonBody/SkeletonBody.vue
// module id = 716
// module chunks = 58